import { render, staticRenderFns } from "./BlogPost.vue?vue&type=template&id=49901142&scoped=true&"
import script from "./BlogPost.vue?vue&type=script&lang=ts&"
export * from "./BlogPost.vue?vue&type=script&lang=ts&"
import style0 from "@/assets/css/ghost.css?vue&type=style&index=0&id=49901142&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49901142",
  null
  
)

export default component.exports